import { createHashedStore } from 'totalinvoice-frontend-core'

const storageKey = "site"

const defaultValues = {
    siteList: [],
}

// TODO only create store if user is logged in
const store = createHashedStore(storageKey, defaultValues)

export { store as siteStore }
